// extracted by mini-css-extract-plugin
module.exports = {"floatAd":"floatAd-eylpm8fG"};